import React, { useState, useContext } from 'react';
import { AppContext } from '../contexts/AppContext';
import Modal from '../components/Modal';

const OnboardingScreen: React.FC = () => {
  const { setUnauthenticatedView, registerAndCreateClub, registrationError } = useContext(AppContext);
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  
  const [adminData, setAdminData] = useState({ name: '', email: '', password: '' });
  const [clubName, setClubName] = useState('');

  const handleAdminSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStep(2);
  };

  const handleClubSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!clubName) return;
    setIsLoading(true);
    const ok = await registerAndCreateClub(adminData.name, adminData.email, adminData.password, clubName);
    setIsLoading(false);

    if (ok) {
      // Mostrar modal con feedback en lugar de alert del navegador
      setModalTitle('Registro completado');
      setModalMessage('Revisa tu correo para confirmar la cuenta y luego iniciá sesión.');
      setModalOpen(true);
    }
  };

  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');

  const closeModalAndGoLogin = () => {
    setModalOpen(false);
    setUnauthenticatedView('login');
  }
  
  const handleAdminChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAdminData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
      <div className="text-center mb-8">
        <a href="#" onClick={(e) => { e.preventDefault(); setUnauthenticatedView('landing'); }} className="inline-block">
          <h1 className="text-4xl font-bold text-gray-800">Tu Club</h1>
        </a>
        <p className="text-gray-500">Comencemos a configurar tu club en 2 simples pasos.</p>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative overflow-hidden">
        {/* Step Indicator */}
        <div className="flex justify-center mb-6">
          {/* Modal de feedback */}
          <Modal isOpen={modalOpen} onClose={closeModalAndGoLogin} title={modalTitle}>
            <p className="text-gray-700">{modalMessage}</p>
            <div className="mt-6 flex justify-end">
              <button onClick={closeModalAndGoLogin} className="bg-blue-600 text-white px-4 py-2 rounded-md">Aceptar</button>
            </div>
          </Modal>
            <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${step >= 1 ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'}`}>1</div>
            <div className="flex-1 h-1 bg-gray-200 my-auto">
                <div className={`h-1 ${step > 1 ? 'bg-blue-600' : 'bg-gray-200'}`} style={{width: '100%'}}></div>
            </div>
            <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${step >= 2 ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'}`}>2</div>
        </div>

        {step === 1 && (
            <div>
              <h2 className="text-xl font-bold text-center mb-1 text-gray-800">Crea tu cuenta de Administrador</h2>
              <p className="text-center text-sm text-gray-500 mb-6">Estos serán tus datos para iniciar sesión.</p>
              <form onSubmit={handleAdminSubmit} className="space-y-4">
                  <input type="text" name="name" placeholder="Tu Nombre Completo" required value={adminData.name} onChange={handleAdminChange} className="w-full p-3 border rounded-md" />
                  <input type="email" name="email" placeholder="Tu Email" required value={adminData.email} onChange={handleAdminChange} className="w-full p-3 border rounded-md" />
                  <input type="password" name="password" placeholder="Creá una Contraseña (mín. 6 caracteres)" required minLength={6} value={adminData.password} onChange={handleAdminChange} className="w-full p-3 border rounded-md" />
                  <button type="submit" className="w-full bg-blue-600 text-white p-3 rounded-md font-semibold hover:bg-blue-700">Siguiente: Datos del Club</button>
              </form>
            </div>
        )}

        {step === 2 && (
            <div>
              <h2 className="text-xl font-bold text-center mb-1 text-gray-800">Registrá tu Club</h2>
              <p className="text-center text-sm text-gray-500 mb-6">¿Cómo se llama el club que vas a gestionar?</p>
              <form onSubmit={handleClubSubmit} className="space-y-4">
                  <input type="text" name="clubName" placeholder="Nombre del Club" required value={clubName} onChange={(e) => setClubName(e.target.value)} className="w-full p-3 border rounded-md" />
                  
                  {registrationError && (
                    <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md" role="alert">
                        <p className="font-bold">Error en el registro</p>
                        <p>{registrationError}</p>
                    </div>
                  )}

                  <div className="flex gap-4">
                    <button type="button" onClick={() => setStep(1)} className="w-full bg-gray-200 text-gray-800 p-3 rounded-md font-semibold hover:bg-gray-300">Volver</button>
                    <button type="submit" disabled={isLoading} className="w-full bg-green-600 text-white p-3 rounded-md font-semibold hover:bg-green-700 disabled:bg-gray-400">
                        {isLoading ? 'Finalizando...' : 'Finalizar y Crear Club'}
                    </button>
                  </div>
              </form>
            </div>
        )}
         <p className="mt-6 text-center text-sm text-gray-500">
          ¿Ya tenés una cuenta?{' '}
          <a href="#" onClick={(e) => { e.preventDefault(); setUnauthenticatedView('login'); }} className="font-medium text-blue-600 hover:text-blue-500">
            Iniciá sesión
          </a>
        </p>
      </div>
    </div>
  );
};
export default OnboardingScreen;